exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".repeat-form-group {\n  float: left;\n  clear: both;\n  margin-bottom: .5em; }\n  .repeat-form-group label {\n    float: left;\n    clear: both;\n    margin-bottom: .7em;\n    font-size: .85em;\n    color: #363636; }\n  .repeat-form-group .single {\n    overflow: hidden;\n    float: left;\n    clear: both;\n    margin-bottom: 1em; }\n  .repeat-form-group .period {\n    display: none; }\n    .repeat-form-group .period.active {\n      display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/repeatSelectComponent.scss
// module id = ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/repeatSelectComponent.scss
// module chunks = main